import React from 'react';
import { Share2, X, Download } from 'lucide-react';
import '../styles/InfoBanner.css';
import ActiveFiltersBar from '../components/ActiveFiltersBar';

const InfoBanner = ({
    selectedCount = 0,
    onBulkShare,
    onClearSelection,
    sortBy = 'importance',
    onSortChange,
    selectedCompanies = [],
    selectedNewsTypes = [],
    selectedRegions = [],
    selectedIndustryNewsDomains = [],
    selectedCustomerDomains = [],
    searchQuery = '',
    companyNames = {},
    newsTypesMap = {},
    regionsMap = {},
    domainNames = {},
    onlyWithTimeline = false,
    onRemoveFilter,
    onResetAll
}) => {
    return (
        <div className="info-banner-news">
            <div className="banner-content-news">
                <div className="banner-icon-news"><img src="/img/news.png" alt="Logo" /></div>
                <div>
                    <h2 className="banner-title-news">Complete News Coverage</h2>
                    <p className="banner-subtitle-news">Top Keywords News</p>
                </div>
                <div className="banner-select-news">
                    {/* <div className="banner-select-news">
                        <div className="impact-info-news">
                            <Download size={16} />
                            <a
                            href="/impact_score.pdf"
                            download="../pdf/Impact_score.pdf"
                            className="impact-info-link-news"
                            >
                            How is Impact Score calculated?
                            </a>
                        </div>
                    </div> */}
                    <span className="sort-by-label-news">Sort by:</span>
                    <select
                        className="importance-select-news"
                        value={sortBy}
                        onChange={(e) => onSortChange && onSortChange(e.target.value)}
                    >
                        <option value="importance">Importance</option>
                        <option value="publish_date">Publish Date</option>
                    </select>
                </div>

            </div>


            <div className="banner-actions-news">
                <p className="feedback-text-news">
                    Your feedback helps us deliver more relevant news! Click on the feedback icon to share your thoughts.
                </p>
                {selectedCount > 0 && (
                    <div className="action-buttons-news">
                        <button
                            className="bulk-share-button-news"
                            onClick={onBulkShare}
                            aria-label={`Share ${selectedCount} selected article${selectedCount > 1 ? 's' : ''}`}
                        >
                            <Share2 size={18} />
                            <span>Share ({selectedCount}/5 selected)</span>
                        </button>
                        <button
                            className="clear-selection-button-news"
                            onClick={onClearSelection}
                            aria-label="Clear all selections"
                        >
                            <X size={18} />
                            <span>Clear </span>
                        </button>
                    </div>
                )}

            </div>
            {/* Active Filters Bar */}
            <ActiveFiltersBar
                selectedCompanies={selectedCompanies}
                selectedNewsTypes={selectedNewsTypes}
                selectedRegions={selectedRegions}
                selectedIndustryNewsDomains={selectedIndustryNewsDomains}
                selectedCustomerDomains={selectedCustomerDomains}
                searchQuery={searchQuery}
                companyNames={companyNames}
                newsTypesMap={newsTypesMap}
                regionsMap={regionsMap}
                domainNames={domainNames}
                onlyWithTimeline={onlyWithTimeline}
                onRemoveFilter={onRemoveFilter}
                onResetAll={onResetAll}
            />
        </div>
    );
};

export default InfoBanner;
